import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[template-host]',
    standalone: false
})
export class TemplateHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { } 
}